<template>
  <div>
    <h2 class="ViewHeading">User Admin</h2>
    <div>
      <b-row>
        <b-col>
          <div>
            <b-card no-body>
              <b-tabs card v-model="tabNo">
                <b-tab active>
                  <template #title>
                    Client Users
                  </template>
                  <b-card-text>
                    <b-card-Group>
                      <b-table
                        :key="componentKey"
                        sticky-header
                        id="ClientTable"
                        :items="clientitems"
                        :fields="fields"
                        no-border-collapse
                        hover
                        show-empty
                        empty-text="You currently dont have any users"
                        responsive
                        small
                      >
                        <template v-slot:cell(Locations)="{ item }">
                          {{ item.Locations.length }}
                        </template>
                        <template v-slot:cell(AccessGroups)="{ item }">
                          {{ item.AccessGroups.length }}
                        </template>
                        <template v-slot:cell(Edit)="{ item }">
                          <b-button
                            variant="outline-info"
                            size="sm"
                            v-on:click="showClientModal(item, 'Edit')"
                          >
                            <BIconPencilSquare> </BIconPencilSquare>
                          </b-button>
                        </template>
                        <template v-slot:cell(Action)="{ item }">
                          <b-button
                            v-if="item.Status == 'Active'"
                            variant="outline-danger"
                            size="sm"
                            v-on:click="showClientModal(item, 'Delete')"
                          >
                            <BIconXSquare> </BIconXSquare>
                          </b-button>
                          <b-button
                            v-if="item.Status != 'Active'"
                            variant="outline-success"
                            size="sm"
                            v-on:click="showClientModal(item, 'Active')"
                          >
                            <BIconCheckSquare> </BIconCheckSquare>
                          </b-button>
                        </template>
                      </b-table>
                      <b-row>
                        <b-col>
                          <b-button
                            variant="outline-secondary"
                            size="sm"
                            @click="showAddNewClient()"
                          >
                            <BIconPlusSquare></BIconPlusSquare> Add new User
                          </b-button>
                        </b-col>
                      </b-row>

                      <b-modal
                        ref="ClientForm"
                        id="ClientForm"
                        title="Client Form"
                        content-class="Modal"
                        header-bg-variant="light"
                        footer-bg-variant="light"
                        lazy
                        ok-only
                        hide-footer
                      >
                        <b-card v-if="this.submitted == false">
                        <div class="d-flex justify-content-center mb-3">
                        <b-spinner label="Submitting..."></b-spinner>
                        <br/>
                        <h3>Submitting...</h3>
                        </div>
                        </b-card>
                        <b-card
                          v-if="this.submitted == true"
                          border-variant="dark"
                          align="center"
                          header-bg-variant="secondary"
                          footer-tag="footer"
                        >
                          <template #header>
                            <h4 class="#">
                              User Update Form
                            </h4>
                          </template>
                          <b-card>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">UserURN</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="User URN"
                                  v-model="clientData.URN"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">First Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  v-if="clientData.Edit == true"
                                  type="text"
                                  placeholder="First Name"
                                  v-model="clientData.FirstName"
                                  required
                                  @focus="modal = false"
                                />
                                <input
                                  v-if="clientData.Delete == true"
                                  type="text"
                                  placeholder="First Name"
                                  v-model="clientData.FirstName"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Last Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  v-if="clientData.Edit == true"
                                  type="text"
                                  placeholder="Last Name"
                                  v-model="clientData.LastName"
                                  required
                                  @focus="modal = false"
                                />
                                <input
                                  v-if="clientData.Delete == true"
                                  type="text"
                                  placeholder="Last Name"
                                  v-model="clientData.LastName"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Default Location</p>
                              </b-col>
                              <b-col sm="8" v-if="clientData.Edit == true">

                                <b-form-select
                                  v-model="clientData.DefaultLocation"
                                >
                                  <option value="" select disabled
                                    >Select Default Location</option
                                  >
                                  <option
                                    v-for="value in clientData.Locations"
                                    :key="value"
                                    v-bind:value="value"
                                    >{{ value }}</option
                                  >
                                </b-form-select>
                              </b-col>
                              <b-col sm="8" v-if="clientData.Delete == true">

                                <input
                                  type="text"
                                  placeholder="Default Location"
                                  v-model="clientData.DefaultLocation"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Location Access</p>
                              </b-col>
                              <b-col sm="8">
                                <b-form-group
                                  v-if="clientData.Edit == true"
                                  class="scrollList"
                                  label=""
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    v-model="clientData.Locations"
                                    :options="locationArray"
                                    :aria-describedby="ariaDescribedby"
                                    name="SelectGroups"
                                    stacked
                                  ></b-form-checkbox-group>
                                </b-form-group>
                                <input
                                  v-if="clientData.Delete == true"
                                  type="text"
                                  placeholder="Locations"
                                  v-model="clientData.Locations"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Portal Access</p>
                              </b-col>
                              <b-col sm="8">
                                <b-form-group
                                  v-if="clientData.Edit == true"
                                  class="scrollList"
                                  label=""
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    v-model="clientData.AccessGroups"
                                    :options="AccessGroupArray"
                                    :aria-describedby="ariaDescribedby"
                                    name="SelectGroups"
                                    stacked
                                  ></b-form-checkbox-group>
                                </b-form-group>
                                <input
                                  v-if="clientData.Delete == true"
                                  type="text"
                                  placeholder="Access Groups"
                                  v-model="clientData.AccessGroups"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Account Status</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  v-if="clientData.Edit == true"
                                  type="text"
                                  placeholder="Location"
                                  v-model="clientData.Status"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                                <input
                                  v-if="clientData.Delete == true"
                                  type="text"
                                  placeholder="Location"
                                  v-model="clientData.Status"
                                  required
                                  readonly
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                          </b-card>
                          <br />

                          <br />
                          <b-row>
                            <b-col>
                              <b-button
                                v-if="clientData.Edit == true"
                                variant="outline-info"
                                v-on:click="editClientUser()"
                              >
                                Submit Changes
                              </b-button>
                              <b-button
                                v-if="this.clientAction == 'Delete'"
                                variant="outline-danger"
                                v-on:click="deleteClientUser()"
                              >
                                Confirm Deletion
                              </b-button>
                              <b-button
                                v-if="this.clientAction == 'Active'"
                                variant="outline-info"
                                v-on:click="activateClientUser()"
                              >
                                Activate User
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="cancelClientModal()"
                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-modal>
                      <b-modal
                        ref="AddInstallerForm"
                        id="AddInstallerForm"
                        title="Add Installer Form"
                        content-class="Modal"
                        header-bg-variant="light"
                        footer-bg-variant="light"
                        lazy
                        ok-only
                        hide-footer
                      >
                      <b-card v-if="this.submitted == false">
                      <div class="d-flex justify-content-center mb-3">
                      <b-spinner label="Submitting..."></b-spinner>
                      <br/>
                      <h3>Submitting...</h3>
                      </div>
                      </b-card>
                        <b-card
                          v-if="this.submitted == true"
                          border-variant="dark"
                          align="center"
                          header-bg-variant="secondary"
                          footer-tag="footer"
                        >
                          <template #header>
                            <h4 class="#">Add Installer Form</h4>
                          </template>

                          <b-card>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">First Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="First Name"
                                  v-model="newInstaller.FirstName"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Last Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="Last Name"
                                  v-model="newInstaller.LastName"
                                  v-on:blur="generateUserName()"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Email</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="Email Address"
                                  v-model="newInstaller.Email"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Location Access</p>
                              </b-col>
                              <b-col sm="8">

                                <b-form-group
                                  class="scrollList"
                                  label=""
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    v-model="newInstaller.Locations"
                                    :options="locationArray"
                                    :aria-describedby="ariaDescribedby"
                                    name="SelectGroups"
                                    stacked
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Default Location</p>
                              </b-col>
                              <b-col sm="8">

                                <b-form-select
                                  v-model="newInstaller.DefaultLocation"
                                >
                                  <option value="" select disabled
                                    >Select Default Location</option
                                  >
                                  <option
                                    v-for="value in newInstaller.Locations"
                                    :key="value"
                                    v-bind:value="value"
                                    >{{ value }}</option
                                  >
                                </b-form-select>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Company</p>
                              </b-col>
                              <b-col sm="8">

                                <b-form-select v-model="newInstaller.Company">
                                  <option value="" select disabled
                                    >Select Company</option
                                  >
                                  <option
                                    v-for="item in companyArray"
                                    :key="item.idx"
                                    v-bind:value="{
                                      name: item.name,
                                      No: item.id,
                                    }"
                                    >{{ item.name }}</option
                                  >
                                </b-form-select>
                              </b-col>
                            </b-row>
                           
                          </b-card>
                          <br />

                          <br />
                          <b-row>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="AddNewInstallerAUTH0()"
                              >
                                Submit
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="ClearInstallerModal()"
                              >
                                Clear
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="cancelInstallerModal()"
                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-modal>

                      <b-modal
                        ref="AddClientForm"
                        id="AddClientForm"
                        title="Add Client Form"
                        content-class="Modal"
                        header-bg-variant="light"
                        footer-bg-variant="light"
                        lazy
                        ok-only
                        hide-footer
                      >
                      <b-card v-if="this.submitted == false">
                        <div class="d-flex justify-content-center mb-3">
                        <b-spinner label="Submitting..."></b-spinner>
                        <br/>
                        <h3>Submitting...</h3>
                        </div>
                        </b-card>
                        <b-card
                          v-if="this.submitted == true"
                          border-variant="dark"
                          align="center"
                          header-bg-variant="secondary"
                          footer-tag="footer"
                        >
                          <template #header>
                            <h4 class="#">Add Client Form</h4>
                          </template>
  

                          <b-card>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">First Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="First Name"
                                  v-model="newClientUser.FirstName"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Last Name</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="Last Name"
                                  v-model="newClientUser.LastName"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Email</p>
                              </b-col>
                              <b-col sm="8">
                                <input
                                  type="text"
                                  placeholder="Email Address"
                                  v-model="newClientUser.Email"
                                  required
                                  @focus="modal = false"
                                />
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Location Access</p>
                              </b-col>
                              <b-col sm="8">
                                <b-form-group
                                  class="scrollList"
                                  label=""
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    v-model="newClientUser.Locations"
                                    :options="locationArray"
                                    :aria-describedby="ariaDescribedby"
                                    name="SelectGroups"
                                    stacked
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Default Location</p>
                              </b-col>
                              <b-col sm="8">
                                <b-form-select
                                  v-model="newClientUser.DefaultLocation"
                                >
                                  <option value="" select disabled
                                    >Select Default Location</option
                                  >
                                  <option
                                    v-for="value in newClientUser.Locations"
                                    :key="value"
                                    v-bind:value="value"
                                    >{{ value }}</option
                                  >
                                </b-form-select>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Portal Access</p>
                              </b-col>
                              <b-col sm="8">
                                <b-form-group
                                  class="scrollList"
                                  label=""
                                  v-slot="{ ariaDescribedby }"
                                >
                                  <b-form-checkbox-group
                                    v-model="newClientUser.AccessGroups"
                                    :options="AccessGroupArray"
                                    :aria-describedby="ariaDescribedby"
                                    name="SelectGroups"
                                    stacked
                                  ></b-form-checkbox-group>
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row>
                              <b-col sm="4">
                                <p id="FormText">Company</p>
                              </b-col>
                              <b-col sm="8">

                                <b-form-select v-model="newClientUser.Company">
                                  <option value="" select disabled
                                    >Select Company</option
                                  >
                                  <option
                                    v-for="item in companyArray"
                                    :key="item.idx"
                                    v-bind:value="{
                                      name: item.name,
                                      No: item.id,
                                    }"
                                    >{{ item.name }}</option
                                  >
                                </b-form-select>
                              </b-col>
                            </b-row>
                          </b-card>
                          <br />

                          <br />
                          <b-row>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="AddNewClientAUTH0()"
                              >
                                Submit
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="ClearClientModal()"
                              >
                                Clear
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="CancelClientModal()"
                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-modal>
                    </b-card-Group>
                  </b-card-text>
                </b-tab>
                <b-tab lazy>
                  <template #title>
                    Maintenance Users
                  </template>
                  <b-table
                    sticky-header
                    id="InstallersTable"
                    :items="installersitems"
                    :fields="fieldsinstallers"
                    no-border-collapse
                    hover
                    show-empty
                    empty-text="You currently dont have any Installers"
                    responsive
                    small
                  >
                
                    <!-- <template v-slot:cell(Edit)="{ item }">
                      <b-button
                        variant="outline-info"
                        size="sm"
                        v-on:click="showInstallerModal(item, 'Edit')"
                      >
                        <BIconPencilSquare> </BIconPencilSquare>
                      </b-button>
                    </template> -->
                    <template v-slot:cell(Action)="{ item }">
                      <b-button
                        v-if="item.Status == 'Active'"
                        variant="outline-danger"
                        size="sm"
                        v-on:click="showInstallerModal(item, 'Delete')"
                      >
                        <BIconXSquare> </BIconXSquare>
                      </b-button>
                      <b-button
                        v-if="item.Status != 'Active'"
                        variant="outline-success"
                        size="sm"
                        v-on:click="showInstallerModal(item, 'Active')"
                      >
                        <BIconCheckSquare> </BIconCheckSquare>
                      </b-button>
                    </template>
                  </b-table>
                  <b-row>
                    <b-col>
                      <b-button
                        variant="outline-secondary"
                        size="sm"
                        @click="showAddNewInstaller()"
                      >
                        <BIconPlusSquare></BIconPlusSquare> Add new
                        Maintenance</b-button
                      >
                    </b-col>
                  </b-row>

                  <b-modal
                    ref="InstallerForm"
                    id="InstallerForm"
                    title="Maintenance Form"
                    content-class="Modal"
                    header-bg-variant="light"
                    footer-bg-variant="light"
                    lazy
                    ok-only
                    hide-footer
                  >
                    <b-card v-if="this.submitted == false">
                        <div class="d-flex justify-content-center mb-3">
                        <b-spinner label="Submitting..."></b-spinner>
                        <br/>
                        <h3>Submitting...</h3>
                        </div>
                        </b-card>
                    <b-card
                      v-if="this.submitted == true"
                      border-variant="dark"
                      align="center"
                      header-bg-variant="secondary"
                      footer-tag="footer"
                    >
                      <template #header>
                        <h4 class="#">
                          Maintenance Update Form
                        </h4>
                      </template>
                      <b-card>
                        <b-row>
                          <b-col sm="4">
                            <p id="FormText">UserURN</p>
                          </b-col>
                          <b-col sm="8">
                            <input
                              type="text"
                              placeholder="User URN"
                              v-model="clientData.URN"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4">
                            <p id="FormText">First Name</p>
                          </b-col>
                          <b-col sm="8">
                            <input
                              v-if="clientData.Edit == true"
                              type="text"
                              placeholder="First Name"
                              v-model="clientData.FirstName"
                              required
                              @focus="modal = false"
                            />
                            <input
                              v-if="clientData.Delete == true"
                              type="text"
                              placeholder="First Name"
                              v-model="clientData.FirstName"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col sm="4">
                            <p id="FormText">Last Name</p>
                          </b-col>
                          <b-col sm="8">
                            <input
                              v-if="clientData.Edit == true"
                              type="text"
                              placeholder="Last Name"
                              v-model="clientData.LastName"
                              required
                              @focus="modal = false"
                            />
                            <input
                              v-if="clientData.Delete == true"
                              type="text"
                              placeholder="Last Name"
                              v-model="clientData.LastName"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col sm="4">
                            <p id="FormText">Default Location</p>
                          </b-col>
                          <b-col>
                            <input
                              type="text"
                              placeholder="Default Location"
                              v-model="clientData.DefaultLocation"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row>
                       
                        <!-- <b-row>
                          <b-col sm="4">
                            <p id="FormText">Location Access</p>
                          </b-col>
                          <b-col sm="8">
      
                            <b-form-group
                              v-if="clientData.Edit == true"
                              class="scrollList"
                              label=""
                              v-slot="{ ariaDescribedby }"
                            >
                              <b-form-checkbox-group
                                v-model="clientData.Locations"
                                :options="locationArray"
                                :aria-describedby="ariaDescribedby"
                                name="SelectGroups"
                                stacked
                              ></b-form-checkbox-group>
                            </b-form-group>
                            <input
                              v-if="clientData.Delete == true"
                              type="text"
                              placeholder="Locations"
                              v-model="clientData.Locations"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row> -->
                        <!-- <b-row>
                          <b-col sm="4">
                            <p id="FormText">Portal Access</p>
                          </b-col>
                          <b-col sm="8">
                            <b-form-group
                              v-if="clientData.Edit == true"
                              class="scrollList"
                              label=""
                              v-slot="{ ariaDescribedby }"
                            >
                              <b-form-checkbox-group
                                v-model="clientData.AccessGroups"
                                :options="AccessGroupArray"
                                :aria-describedby="ariaDescribedby"
                                name="SelectGroups"
                                stacked
                              ></b-form-checkbox-group>
                            </b-form-group>
                            <input
                              v-if="clientData.Delete == true"
                              type="text"
                              placeholder="Access Groups"
                              v-model="clientData.AccessGroups"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row> -->
                        <b-row>
                          <b-col sm="4">
                            <p id="FormText">Account Status</p>
                          </b-col>
                          <b-col sm="8">
                            <input
                              v-if="clientData.Edit == true"
                              type="text"
                              placeholder="Status"
                              v-model="clientData.Status"
                              required
                              readonly
                              @focus="modal = false"
                            />
                            <input
                              v-if="clientData.Delete == true"
                              type="text"
                              placeholder="Status"
                              v-model="clientData.Status"
                              required
                              readonly
                              @focus="modal = false"
                            />
                          </b-col>
                        </b-row>

                      </b-card>
                      <br />

                      <br />
                      <b-row>
                        <b-col>
                          <b-button
                            v-if="clientData.Edit == true"
                            variant="outline-info"
                            v-on:click="editClientUser()"
                          >
                            Submit Changes
                          </b-button>
                          <b-button
                            v-if="this.clientAction == 'Delete'"
                            variant="outline-danger"
                            v-on:click="deleteClientUser()"
                          >
                            Confirm Deletion
                          </b-button>
                          <b-button
                            v-if="this.clientAction == 'Active'"
                            variant="outline-info"
                            v-on:click="activateClientUser()"
                          >
                            Activate User
                          </b-button>
                        </b-col>
                        <b-col>
                          <b-button
                            variant="outline-info"
                            v-on:click="cancelClientModal()"
                          >
                            Cancel
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-modal>
                </b-tab>
              </b-tabs>
            </b-card>
          </div>
        </b-col>
      </b-row>
     
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BIconPencilSquare,
  BIconXSquare,
  BIconPlusSquare,
  BIconCheckSquare,
} from "bootstrap-vue";

export default {
  components: {
    BIconPencilSquare,
    BIconXSquare,
    BIconPlusSquare,
    BIconCheckSquare,
  },
  data() {
    return {
      companyArray: [],
      DivID: "",
      fName: "",
      lName: "",
      locationsArray: [],
      clCompany: localStorage.getItem("Company"),
      clDept: "",
      clLocation: localStorage.getItem("CurrentLocation"),
      clEmail: "",
      clURN: "",
      UserFirstNameSearch: "",
      UserSurnameSearch: "",
      deactclURN: "",
      deactclFName: "",
      deactclLName: "",
      deactclDept: "",
      deactclLoc: "",
      locAddress: "",
      locTele: "",
      locEscEmail: "",
      locEscName: "",
      locFloor: "",
      locBuildingName: "",
      locArea: "",
      locations: "",
      location: "",
      filteredlocations: "",
      editLocAddress: "",
      editLocBuildingName: "",
      editLocArea: "",
      editLocEscName: "",
      editLocEscEmail: "",
      editLocEscTele: "",
      insFName: "",
      insLName: "",
      insEmail: "",
      insCompany: localStorage.getItem("Company"),
      insURN: "",
      locCountry: "",
      CountriesArray: [],
      RegionsArray: [],
      CountriesList: [],
      RegionsList: [],
      locRegion: [],
      editLocCountry: "",
      selectedSearch: "",
      selectedAction: "",
      HistoryNote: "",
      UserURN: localStorage.getItem("UserURN"),
      UserProfile: localStorage.getItem("profileportal"),
      ParentCompany: localStorage.getItem("ParentCompany"),
      deviceArray: [],
      SearchDeviceID: "",
      DeactID: "",
      DeactBuilding: "",
      DeactVersion: "N/A",
      DeactCurrentStatus: "",
      DeactPosition: "",
      DeactFeed: "",
      DeactFloor: "",
      DeactReturn: "",
      Suspendeddevicelist: [],
      SuspendeddeviceArray: [],
      deactInsURN: "",
      deactInsFName: "",
      deactInsLName: "",
      deactInsEmail: "",
      deactInsStatus: "",
      ClientList: [],
      ClientListArray: [],
      clientSelection: "",
      InstallerList: [],
      InstallerListArray: [],
      installerSelection: "",
      insPassword: "",
      nickname: "",
      subGroupLocationToSearch: "",
      deviceSubgroup: "",
      subgroupListArray: "",
      editSubgroupName: "",
      // buttonCooldown: false,
      newClientUser: {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
        AccessGroups: [],
      },
      newInstaller: {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
        AccessGroups: [],
      },
      componentKey: 0,
      installersitems: [],
      fieldsinstallers: [
        // { key: "URN", variant: "primary" },
        { key: "FirstName", variant: "primary" },
        { key: "LastName", variant:"primary" },
        { key: "DefaultLocation", label: "Base Location" },
        { key: "Company" },
        { key: "ParentCompany" },
        { key: "Status" },
        // { key: "Edit" },
        { key: "Action" },
      ],
      optionsinstallers: [],

      clientitems: [],
      fields: [
        // { key: "URN", variant: "primary" },
        { key: "FirstName", variant: "primary" },
        { key: "LastName", variant: "primary" },
        { key: "DefaultLocation" },
        { key: "Company" },
        { key: "Locations" },
        { key: "AccessGroups" },
        { key: "Status" },
        { key: "Edit" },
        { key: "Action" },
      ],
      clientData: "",
      clientAction: "",
      options: [],
      locationArray: [],
      selected: "",
      clearUserData: [],

      // Just to stop the stupid errors

      deactInsUsername: "",
      InsUsername: "",
      InsLName: "",
      InsFName: "",
      AccessGroupArray: [],
      submitted: true,
      tabNo: 0
    };
  },
  beforeMount(){
    this.tabNo = this.$tab;
  },
  mounted() {
    // let LookUpUrl3 =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeaders3 = this.$apikeyPost;
    // this.LookUpRequest3 = { RequestType: "Location", Company: this.clCompany };
    // axios
    //   .post(LookUpUrl3, this.LookUpRequest3, LookUpHeaders3)
    //   .then((response) => {
    //     response;
    //     this.locationslist = response.data.Values;
    //     for (let i = 0; i < this.locationslist.length; i++) {
    //       var QuoteStr4 = this.locationslist[i][0];
    //       this.locationsArray.push({
    //         id: QuoteStr4,
    //         location: this.locationslist[i][2],
    //         address: this.locationslist[i][1],
    //       });
    //     }
    //   });

    let LookUpUrlAccessGroup =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersAccessGroup = this.$apikeyPost;
    this.LookUpRequest3 = { RequestType: "AllAccessGroups" };
    axios
      .post(LookUpUrlAccessGroup, this.LookUpRequest3, LookUpHeadersAccessGroup)
      .then((response) => {
        let accessgrouplist = response.data.Values;
        for (let i = 0; i < accessgrouplist.length; i++) {
          this.AccessGroupArray.push({
            text: accessgrouplist[i][1],
            value: accessgrouplist[i][2],
          });
        }
      });

    let LookUpUrlExistingLocation =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingLocation = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentCompanyLocations",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingLocation,
        this.LookUpRequest,
        LookUpHeadersExistingLocation
      )
      .then((response) => {
        this.locationList = response.data.Values;

        for (let i = 0; i < this.locationList.length; i++) {
          var QuoteStr4 = this.locationList[i][2];
          this.locationArray.push({
            text: QuoteStr4,
            value: QuoteStr4,
          });
        }
      });

    let LookUpUrlExistingCompany =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/sulookups";
    let LookUpHeadersExistingCompany = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentChildCompanies",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(
        LookUpUrlExistingCompany,
        this.LookUpRequest,
        LookUpHeadersExistingCompany
      )
      .then((response) => {
        this.companyList = response.data.Values;

        for (let i = 0; i < this.companyList.length; i++) {
          this.companyArray.push({
            name: this.companyList[i][0],
            id: this.companyList[i][8],
          });
        }
      });

    let LookUpUrlINS =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/userlookups";
    let LookUpHeadersINS = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentMaints",
      UserURN: "",
      FirstName: "",
      LastName: "",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(LookUpUrlINS, this.LookUpRequest, LookUpHeadersINS)
      .then((response) => {
        let userListINS = response.data.Values;

        this.installersitems = [];
        for (let i = 0; i < userListINS.length; i++) {
          this.installersitems.push({
            URN: userListINS[i][0],
            FirstName: userListINS[i][1],
            LastName: userListINS[i][2],
            DefaultLocation: userListINS[i][7],
            Company: userListINS[i][5],
            ParentCompany: userListINS[i][6],
            Status: userListINS[i][8],
            Edit: "",
            Action: "",
          });
        }
      });

    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/userlookups";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "ParentClients",
      UserURN: "",
      FirstName: "",
      LastName: "",
      RequestVariable: this.ParentCompany,
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let userList = response.data.Values;
        for (let i = 0; i < userList.length; i++) {
          this.clientitems.push({
            URN: userList[i][0],
            FirstName: userList[i][1],
            LastName: userList[i][2],
            DefaultLocation: userList[i][7],
            Locations: userList[i][9],
            Company: userList[i][6],
            Status: userList[i][8],
            AccessGroups: userList[i][10],
            Edit: "",
            Action: "",
          });
        }

      });

    // let LookUpUrlLocation =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/locations";
    // let LookUpHeadersLocation = this.$apikeyPost;
    // this.LookUpRequestLocation = {
    //   RequestType: "Location",
    //   LocationDict: [{ Company: this.clCompany }],
    // };
    // axios
    //   .post(
    //     LookUpUrlLocation,
    //     this.LookUpRequestLocation,
    //     LookUpHeadersLocation
    //   )
    //   .then((response) => {
    //     this.locations = response.data.Values;
    //   });

    // let LookUpUrlCountry =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersCountry = this.$apikeyPost;
    // let LookUpRequestCountry = { RequestType: "CountryAll" };
    // axios
    //   .post(LookUpUrlCountry, LookUpRequestCountry, LookUpHeadersCountry)
    //   .then((response) => {
    //     this.CountriesList = response.data.Values;
    //     for (let i = 0; i < this.CountriesList.length; i++) {
    //       var QuoteStr4 = this.CountriesList[i][0];
    //       this.CountriesArray.push({
    //         id: QuoteStr4,
    //         Country: this.CountriesList[i][1],
    //       });
    //     }
    //   });
    // let LookUpUrlDevice =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersDevice = this.$apikeyPost;
    // let LookUpRequestDevice = {
    //   RequestType: "DeviceActive",
    //   Company: this.clCompany,
    // };
    // axios
    //   .post(LookUpUrlDevice, LookUpRequestDevice, LookUpHeadersDevice)
    //   .then((response) => {
    //     this.devicelist = response.data.Values;
    //     for (let i = 0; i < this.devicelist.length; i++) {
    //       var QuoteStr1 = this.devicelist[i][0];
    //       if (QuoteStr1.length === 10) {
    //         let DeviceIDCut = QuoteStr1.slice(0, 9);
    //         this.deviceArray.push({
    //           id: DeviceIDCut,
    //           Location: this.devicelist[i][1],
    //           Floor: this.devicelist[i][2],
    //           Position: this.devicelist[i][3],
    //         });
    //         i = i + 1;
    //       } else if (QuoteStr1.length === 9) {
    //         this.deviceArray.push({
    //           id: QuoteStr1,
    //           Location: this.devicelist[i][1],
    //           Floor: this.devicelist[i][2],
    //           Position: this.devicelist[i][3],
    //         });
    //       }
    //     }
    //   });

    // let LookUpUrlSuspendedDevice =
    //   "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
    //   this.$environment +
    //   "/lookup";
    // let LookUpHeadersSuspendedDevice = this.$apikeyPost;
    // let LookUpRequestSuspendedDevice = {
    //   RequestType: "DeviceSuspended",
    //   Company: this.clCompany,
    // };

    // axios
    //   .post(
    //     LookUpUrlSuspendedDevice,
    //     LookUpRequestSuspendedDevice,
    //     LookUpHeadersSuspendedDevice
    //   )
    //   .then((response) => {
    //     this.Suspendeddevicelist = response.data.Values;
    //     for (let i = 0; i < this.Suspendeddevicelist.length; i++) {
    //       var QuoteStr1 = this.Suspendeddevicelist[i][0];
    //       this.SuspendeddeviceArray.push({
    //         id: QuoteStr1,
    //         Location: this.Suspendeddevicelist[i][3],
    //         Floor: this.Suspendeddevicelist[i][6],
    //         Position: this.Suspendeddevicelist[i][5],
    //       });
    //     }
    //   });
  },
  methods: {
    
    showClientModal(Data, Action) {
      (this.clientData = Data), (this.clientAction = Action);
      if (this.clientAction == "Edit") {
        this.clientData.Edit = true;
        this.clientData.Delete = false;
      }
      if (this.clientAction == "Delete" || this.clientAction == "Active") {
        this.clientData.Edit = false;
        this.clientData.Delete = true;
      }
      this.clearUserData = Data;
      if (this.clientAction == "Edit") {
        this.clearUserData.Edit = true;
        this.clearUserData.Delete = false;
      }
      if (this.clientAction == "Delete" || this.clientAction == "Active") {
        this.clearUserData.Edit = false;
        this.clearUserData.Delete = true;
      }
      this.showModal("ClientForm");
    },
    showInstallerModal(Data, Action) {
      (this.clientData = Data), (this.clientAction = Action);
      if (this.clientAction == "Edit") {
        this.clientData.Edit = true;
        this.clientData.Delete = false;
      }
      if (this.clientAction == "Delete" || this.clientAction == "Active") {
        this.clientData.Edit = false;
        this.clientData.Delete = true;
      }
      this.clearUserData = Data;
      if (this.clientAction == "Edit") {
        this.clearUserData.Edit = true;
        this.clearUserData.Delete = false;
      }
      if (this.clientAction == "Delete" || this.clientAction == "Active") {
        this.clearUserData.Edit = false;
        this.clearUserData.Delete = true;
      }
      this.showModal("InstallerForm");
    },
    showAddNewClient() {
      this.showModal("AddClientForm");
    },
    showAddNewInstaller() {
      this.showModal("AddInstallerForm");
    },

    activateClientUser() {
      this.submitted = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/auth0";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Unblock",
        UserID: this.clientData.URN,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;
          this.activateClientUserDB();
          this.submitted = true
        });
    },

    activateClientUserDB() {
      let LookUpUrl9 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeaders9 = this.$apikeyPost;
      let LookUpRequest9 = {
        RequestType: "Reactivate",
        UserDict: [
          {
            UserURN: this.clientData.URN,
          },
        ],
      };
      axios
        .post(LookUpUrl9, LookUpRequest9, LookUpHeaders9)
        .then((response) => {
          response;
          alert("User has been reactivated");
          this.clientData = [];
          this.resetClientTable();
        });
    },

    editClientUser() {
      if (
        (this.clientData.URN != "") &
        (this.clientData.DefaultLocation != "") &
        (this.clientData.Edit == true) &
        (this.clientData.FirstName != "") &
        (this.clientData.LastName != "") &
        (this.clientData.Locations != "") &
        (this.clientData.Status != "") &
        (this.clientData.AccessGroups != "") &
        (this.clientData.Locations != [])
      ) {
        this.submitted = false
        let LookUpUrl9 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeaders9 = this.$apikeyPost;
        let LookUpRequest9 = {
          Blocked: "",
          RequestType: "Update",
          Email: "",
          UserMetaCompany: this.clientData.Company,
          UserMetaLocation: this.clientData.DefaultLocation,
          AppMetaAccess: this.clientData.AccessGroups,
          AppMetaPortal: "CLI",
          FirstName: this.clientData.FirstName,
          LastName: this.clientData.LastName,
          Name: this.clientData.FirstName + " " + this.clientData.LastName,
          UserID: this.clientData.URN,
        };
        axios
          .post(LookUpUrl9, LookUpRequest9, LookUpHeaders9)
          .then((response) => {
            response;
            this.editClientUserDB();
            this.submitted = true
          });
      } else {
        alert("Please ensure all fields are filled");
      }
    },

    editClientUserDB() {
      if (
        (this.clientData.URN != "") &
        (this.clientData.DefaultLocation != "") &
        (this.clientData.Edit == true) &
        (this.clientData.FirstName != "") &
        (this.clientData.LastName != "") &
        (this.clientData.Locations != "") &
        (this.clientData.Status != "") &
        (this.clientData.AccessGroups != "") &
        (this.clientData.Locations != [])
      ) {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/useradmin";
        let LookUpHeaders = this.$apikeyPost;
        let LookUpRequest = {
          RequestType: "Edit",
          UserDict: [
            {
              UserURN: this.clientData.URN,
              FirstName: this.clientData.FirstName,
              LastName: this.clientData.LastName,
              Location: this.clientData.Locations,
              DefaultLocation: this.clientData.DefaultLocation,
              AccessGroups: this.clientData.AccessGroups,
            },
          ],
        };
        axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
          response;
          this.clientData = [];
        });
        this.resetClientTable()
      
        
      } else {
        alert("Please ensure all fields are filled");
      }
    },
    cancelClientModal() {
      this.hideModal("ClientForm");
      this.hideModal("InstallerForm");
    },
    cancelInstallerModal() {
      this.hideModal("AddInstallerForm");
    },

    deleteClientDB() {
      if (this.clientData.URN != "") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/useradmin";
        let LookUpHeaders = this.$apikeyPost;
        let LookUpRequest = {
          RequestType: "Delete",
          UserDict: [
            {
              UserURN: this.clientData.URN,
            },
          ],
        };
        axios.post(LookUpUrl, LookUpRequest, LookUpHeaders).then((response) => {
          response;
          this.clientData = [];
          this.resetClientTable();
        });
      } else {
        alert("Please ensure all fields are filled");
      }
    },

    resetClientTable() {
      if (this.tabNo == 0){
        let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/userlookups";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "ParentClients",
        UserURN: "",
        FirstName: "",
        LastName: "",
        RequestVariable: this.ParentCompany,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let userList = response.data.Values;
          this.clientitems = [];
          for (let i = 0; i < userList.length; i++) {
            this.clientitems.push({
              URN: userList[i][0],
              FirstName: userList[i][1],
              LastName: userList[i][2],
              DefaultLocation: userList[i][7],
              Locations: userList[i][9],
              Company: userList[i][6],
              Status: userList[i][8],
              AccessGroups: userList[i][10],
              Edit: "",
              Action: "",
            });
            this.hideModal("ClientForm");
        }
      });
    }
        if (this.tabNo == 1){
          let LookUpUrlINS =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/userlookups";
          let LookUpHeadersINS = this.$apikeyPost;
          this.LookUpRequest = {
            RequestType: "ParentMaints",
            UserURN: "",
            FirstName: "",
            LastName: "",
            RequestVariable: this.ParentCompany,
          };
          axios
            .post(LookUpUrlINS, this.LookUpRequest, LookUpHeadersINS)
            .then((response) => {
              let userListINS = response.data.Values;

              this.installersitems = [];
              for (let i = 0; i < userListINS.length; i++) {
                this.installersitems.push({
                  URN: userListINS[i][0],
                  FirstName: userListINS[i][1],
                  LastName: userListINS[i][2],
                  DefaultLocation: userListINS[i][7],
                  Company: userListINS[i][5],
                  ParentCompany: userListINS[i][6],
                  Status: userListINS[i][8],
                  Edit: "",
                  Action: "",
                });
              }
            });

          this.hideModal("InstallerForm");

        }
        this.componentKey += 1;
      },

    deleteClientUser() {
      this.submitted = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/auth0";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Block",
        UserID: this.clientData.URN,
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          response;

          this.deleteClientDB();
          this.submitted = true
        });
    },

    // btnCooldown: function() {
    //   let buttonid = "button";
    //   const button = document.querySelector("#" + buttonid + "");
    //   if (this.buttonCooldown == true) {
    //     const disableButton = () => {
    //       button.disabled = true;
    //     };
    //     button.addEventListener("click", disableButton);
    //   } else if (this.buttonCooldown == false) {
    //     button.disabled = false;
    //   }
    // },
    showModal(Modal) {
      this.DivID = "";
      this.$refs[Modal].show();
    },
    hideModal(Modal) {
      this.$refs[Modal].hide();
    },

    resetForm(Type) {
      if (Type == "Client"){
      this.hideModal("AddClientForm");
      this.newClientUser = {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
      };

      this.clientitems = [];

      let LookUpUrlClient =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/userlookups";
      let LookUpHeadersClient = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "ParentClients",
        UserURN: "",
        FirstName: "",
        LastName: "",
        RequestVariable: this.ParentCompany,
      };
      axios
        .post(LookUpUrlClient, this.LookUpRequest, LookUpHeadersClient)
        .then((response) => {
          response;
          let userList = response.data.Values;

          for (let i = 0; i < userList.length; i++) {
            this.clientitems.push({
              URN: userList[i][0],
              FirstName: userList[i][1],
              LastName: userList[i][2],
              DefaultLocation: userList[i][7],
              Locations: userList[i][9],
              Company: userList[i][6],
              Status: userList[i][8],
              AccessGroups: userList[i][10],
              Edit: "",
              Action: "",
            });
          }
        });
      }
      if(Type == "Installer"){
        this.hideModal("AddInstallerForm");
        this.newClientUser = {
          URN: "",
          FirstName: "",
          LastName: "",
          Locations: [],
          DefaultLocation: "",
          Email: "",
          Company: [],
        };

        this.clientitems = [];
      }
    },

    ClearClientModal() {
      // Add new user clear
      this.newClientUser = {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
      };

      //Edit/Delete Clear
    },

    CancelClientModal() {
      this.newClientUser = {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
      };
      this.hideModal("AddClientForm");
    },
    ClearInstallerModal() {
      // Add new installer clear
      this.newInstaller = {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
      };

      //Edit/Delete Clear
    },
    cancelNewInstallerModal() {
      this.newInstaller = {
        URN: "",
        FirstName: "",
        LastName: "",
        Locations: [],
        DefaultLocation: "",
        Email: "",
        Company: [],
      };
    },
    AddNewClientAUTH0() {
      if (
        (this.newClientUser != "") &
        (this.newClientUser.DefaultLocation != "") &
        (this.newClientUser.Email != "") &
        (this.newClientUser.FirstName != "") &
        (this.newClientUser.LastName != "") &
        (this.newClientUser.AccessGroups != []) &
        (this.newClientUser.Locations != [])
      ) {
        var randomNo1 = Math.floor(Math.random() * 9);
        var randomNo2 = Math.floor(Math.random() * 9);
        var randomNo3 = Math.floor(Math.random() * 9);
        var randomNo4 = Math.floor(Math.random() * 9);

        let totalNo = randomNo1.toString(10);
        totalNo = totalNo + randomNo2.toString(10);
        totalNo = totalNo + randomNo3.toString(10);
        totalNo = totalNo + randomNo4.toString(10);
        var clientNickname = "";
        clientNickname =
          this.newClientUser.FirstName.slice(0, 3) +
          this.newClientUser.LastName.slice(0, 3);
        clientNickname = clientNickname + totalNo;
        this.submitted = false

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Create",
          Email: this.newClientUser.Email,
          UserMetaCompany: this.newClientUser.Company.name,
          UserMetaLocation: this.newClientUser.DefaultLocation,
          UserMetaParentCompany: localStorage.getItem("ParentCompany"),
          AppMetaAccess: this.newClientUser.AccessGroups,
          AppMetaPortal: "CLI",
          FirstName: this.newClientUser.FirstName,
          LastName: this.newClientUser.LastName,
          Name:
            this.newClientUser.FirstName + " " + this.newClientUser.LastName,
          UserID: "",
          Username: clientNickname,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            this.clURN = response.data.Values.user_id;
            this.AddNewClientDB(clientNickname);
            this.submitted = true
          });
      } else {
        alert(
          "Please ensure all required fields are filled in (Company is not required)."
        );
      }
    },
    AddNewClientDB(clientNickname) {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Create",
        UserDict: [
          {
            UserURN: this.clURN,
            FirstName: this.newClientUser.FirstName,
            LastName: this.newClientUser.LastName,
            Email: this.newClientUser.Email,
            Company: this.newClientUser.Company.name,
            DefaultLocation: this.newClientUser.DefaultLocation,
            Location: this.newClientUser.Locations,
            ParentCompany: localStorage.getItem("ParentCompany"),
            UserType: "CLI",
            ConsentGiven: "FALSE",
            Username: clientNickname,
            AccessGroups: this.newClientUser.AccessGroups,
          },
        ],
      };

      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          // this.buttonCooldown = false;
          this.HistoryNote = "Added Client";
          this.HistorySubmit();
          alert("Client has been created");
          (this.newClientUser = {
            URN: "",
            FirstName: "",
            LastName: "",
            Locations: [],
            DefaultLocation: "",
            Email: "",
            Company: [],
          }),
            this.resetForm("Client");
        });
    },

    DeactivateClient() {
      // this.buttonCooldown = true;

      let LookUpURLSubmit =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeadersSubmit = this.$apikeyPost;
      let LookUpRequestSubmit = {
        RequestType: "Delete",
        UserType: "CEU",
        UserDict: [{ UserURN: this.deactclURN }],
      };

      axios
        .post(LookUpURLSubmit, LookUpRequestSubmit, LookUpHeadersSubmit)
        .then((response) => {
          response;
          // this.buttonCooldown = false;
          this.HistoryNote = "Deactivated Client";
          this.HistorySubmit();
          alert("Client has been deleted");
          this.DivID = "";
        });
    },

    DeactivateInstaller() {
      // this.buttonCooldown = true;

      let LookUpURLSubmitIns =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeadersSubmitIns = this.$apikeyPost;
      let LookUpRequestSubmitIns = {
        RequestType: "Delete",
        UserType: "INS",
        UserDict: [{ UserURN: this.deactInsURN }],
      };
      axios
        .post(
          LookUpURLSubmitIns,
          LookUpRequestSubmitIns,
          LookUpHeadersSubmitIns
        )
        .then((response) => {
          response;
          // this.buttonCooldown = false;
          this.HistoryNote = "Deactivated Installer " + this.deactInsURN;
          this.HistorySubmit();
          alert("Installer has been deactivated");
          this.DivID = "";
        });
    },

    generateUserName: function() {
      var randomNo1 = Math.floor(Math.random() * 9);
      var randomNo2 = Math.floor(Math.random() * 9);
      var randomNo3 = Math.floor(Math.random() * 9);
      var randomNo4 = Math.floor(Math.random() * 9);

      let totalNo = randomNo1.toString(10);
      totalNo = totalNo + randomNo2.toString(10);
      totalNo = totalNo + randomNo3.toString(10);
      totalNo = totalNo + randomNo4.toString(10);

      this.nickname = "";
      this.nickname =
        this.newInstaller.FirstName.slice(0, 3) +
        this.newInstaller.LastName.slice(0, 3);
      this.nickname = this.nickname + totalNo;
    },

    AddNewInstallerAUTH0() {
      // this.buttonCooldown = true;

      if (
        this.newInstaller.FirstName == "" ||
        this.newInstaller.LastName == "" ||
        this.newInstaller.Email == ""
      ) {
        alert("Please ensure all fields are filled");
      } else {
        this.submitted = false
        this.insEmail = this.nickname + "@seraphprotectlogin.com";

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/auth0";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "Create",
          Email: this.newInstaller.Email,
          UserMetaCompany: this.newInstaller.Company.name,
          UserMetaLocation: this.newInstaller.DefaultLocation,
          UserMetaParentCompany: localStorage.getItem("ParentCompany"),
          AppMetaAccess: this.newInstaller.AccessGroups,
          AppMetaPortal: "MAI",
          FirstName: this.newInstaller.FirstName,
          LastName: this.newInstaller.LastName,
          Name: this.newInstaller.FirstName + " " + this.newInstaller.LastName,
          UserID: "",
          Username: this.nickname,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            // this.buttonCooldown = false;
            this.insURN = response.data.Values.user_id;
            this.AddNewInstallerDB();
            this.submitted = true
            this.resetClientTable();
          });
      }
    },

    AddNewInstallerDB() {
      let LookUpUrlDB =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/useradmin";
      let LookUpHeadersDB = this.$apikeyPost;
      this.LookUpRequest = {
        RequestType: "Create",
        UserType: "INS",
        UserDict: [
          {
            UserURN: this.insURN,
            FirstName: this.newInstaller.FirstName,
            LastName: this.newInstaller.LastName,
            Company: this.newInstaller.Company.name,
            Email: this.newInstaller.Email,
            Username: this.nickname,
            DefaultLocation: this.newInstaller.DefaultLocation,
            Location: this.newInstaller.Locations,
            ParentCompany: localStorage.getItem("ParentCompany"),
            UserType: "MAI",
            ConsentGiven: "FALSE",
            AccessGroups: this.newInstaller.AccessGroups,
          },
        ],
      };
      axios
        .post(LookUpUrlDB, this.LookUpRequest, LookUpHeadersDB)
        .then((response) => {
          response;
          this.HistoryNote = "Added Installer";
          this.HistorySubmit();
          alert("Installer has been created");
          this.resetForm("Installer")
        });
    },

    HistorySubmit() {
      let current = new Date();
      let HistoryDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
      let HistoryTime =
        current.getHours() +
        ":" +
        current.getMinutes({ minimumIntegerDigits: 2 }) +
        ":" +
        current.getSeconds({ minimumIntegerDigits: 2, useGrouping: false });

      let LookUpURLHist =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/adminhistory";
      let LookUpHeadersHist = this.$apikeyPost;
      this.LookUpRequest = {
        UserURN: this.UserURN,
        HistoryDate: HistoryDate,
        HistoryTime: HistoryTime,
        HistoryNote: this.HistoryNote,
        ProfilePortal: this.UserProfile,
      };
      axios
        .post(LookUpURLHist, this.LookUpRequest, LookUpHeadersHist)
        .then((response) => {
          response;
        });
    },

    LookUpSubmit: function(Lookup) {
      // this.buttonCooldown = true;
      if (Lookup === "ClientDeactivate") {
        let LookUpURLCl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userlookups";
        let LookUpHeadersCl = this.$apikeyPost;
        let LookUpRequestCl = {
          RequestType: "Name",
          UserType: "CEU",
          Company: this.clCompany,
          UserURN: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
        };

        axios
          .post(LookUpURLCl, LookUpRequestCl, LookUpHeadersCl)
          .then((response) => {
            // this.buttonCooldown = false;

            if (response.data.Values == "Invalid Name") {
              // this.buttonCooldown = false;
              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.deactclURN = response.data.Values[0][0];
              this.deactclFName = response.data.Values[0][1];
              this.deactclLName = response.data.Values[0][2];
              this.deactclDept = response.data.Values[0][3];
              this.deactclLoc = response.data.Values[0][6];
              this.hideModal("ClientDeactivateModal");
              this.DivID = "Client Deactivate";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.ClientList = response.data.Values;
              for (let i = 0; i < this.ClientList.length; i++) {
                var QuoteStr1 = this.ClientList[i][0];
                this.ClientListArray.push({
                  urn: QuoteStr1,
                  FirstName: this.ClientList[i][1],
                  LastName: this.ClientList[i][2],
                  Location: this.ClientList[i][6],
                  Department: this.ClientList[i][3],
                });
              }
              this.hideModal("ClientDeactivateModal");
              this.showModal("ClientSelectionModal");
            }
          });
      }

      if (Lookup === "ClientSelection") {
        let LookUpURLCl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userlookups";
        let LookUpHeadersCl = this.$apikeyPost;
        let LookUpRequestCl = {
          RequestType: "UserURN",
          UserType: "CEU",
          UserURN: this.clientSelection.urn,
          FirstName: "",
          LastName: "",
        };
        axios
          .post(LookUpURLCl, LookUpRequestCl, LookUpHeadersCl)
          .then((response) => {
            // this.buttonCooldown = false;

            this.deactclURN = response.data.Values[0][0];
            this.deactclFName = response.data.Values[0][1];
            this.deactclLName = response.data.Values[0][2];
            this.deactclDept = response.data.Values[0][3];
            this.deactclLoc = response.data.Values[0][6];
            this.hideModal("ClientSelectionModal");
            this.DivID = "Client Deactivate";
            this.UserFirstNameSearch = "";
            this.UserSurnameSearch = "";
          });
      }
      /* INSTALLER USER |_|_|_|_|_|_|_|_|_|_|_|_|_|_|_|_| */
      if (Lookup === "InstallerDeactivate") {
        let LookUpURLINS =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/userlookups";
        let LookUpHeadersINS = this.$apikeyPost;
        let LookUpRequestINS = {
          RequestType: "Name",
          UserType: "INS",
          Company: this.clCompany,
          UserURN: "",
          FirstName: this.UserFirstNameSearch,
          LastName: this.UserSurnameSearch,
        };

        axios
          .post(LookUpURLINS, LookUpRequestINS, LookUpHeadersINS)
          .then((response) => {
            // this.buttonCooldown = false;

            if (response.data.Values == "Invalid Name") {
              // this.buttonCooldown = false;
              alert("Please ensure the name entered is correct");
            } else if (response.data.Values[1] == null) {
              this.deactInsURN = response.data.Values[0][0];
              this.deactInsFName = response.data.Values[0][1];
              this.deactInsLName = response.data.Values[0][2];
              this.deactInsEmail = response.data.Values[0][3];
              this.deactInsStatus = response.data.Values[0][6];
              this.hideModal("InstallerDeactivateModal");
              this.DivID = "Installer Deactivate";
              this.UserFirstNameSearch = "";
              this.UserSurnameSearch = "";
            } else if (response.data.Values[1] != "") {
              this.InstallerList = "";
              this.InstallerList = response.data.Values;
              for (let i = 0; i < this.InstallerList.length; i++) {
                var QuoteStr1 = this.InstallerList[i][0];
                this.InstallerListArray.push({
                  urn: QuoteStr1,
                  FirstName: this.InstallerList[i][1],
                  LastName: this.InstallerList[i][2],
                  nickname: this.InstallerList[i][4],
                });
              }
              this.hideModal("InstallerDeactivateModal");
              this.showModal("InstallerSelectionModal");
            }
          });
      }
      if (Lookup === "EditLocation") {
        let LookUpURLEditLoc =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/locations";
        let LookUpHeadersEditLoc = this.$apikeyPost;
        let LookUpRequestEditLoc = {
          RequestType: "EscDetails",
          LocationDict: [
            { Location: this.location.text, Company: this.clCompany },
          ],
        };
        axios
          .post(LookUpURLEditLoc, LookUpRequestEditLoc, LookUpHeadersEditLoc)
          .then((response) => {
            // this.buttonCooldown = false;
            this.editLocAddress = response.data.Values[0][0];
            this.editLocBuildingName = response.data.Values[0][1];
            this.editLocArea = response.data.Values[0][2];
            this.editLocCountry = response.data.Values[0][3];
            this.editLocEscName = response.data.Values[0][4];
            this.editLocEscEmail = response.data.Values[0][5];
            this.editLocEscTele = response.data.Values[0][6];
            this.hideModal("LocationEditModal");
            this.DivID = "EditLoc";
            this.location = "";
          });
      }
      if (Lookup === "DeactDevice") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/search";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "DeviceID",
          RequestVariable: this.SearchDeviceID.id,
          Company: this.Company,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            // this.buttonCooldown = false;
            let ResponseArray = response.data.Values;
            if (ResponseArray[1] != null) {
              let substringid = ResponseArray[0][0].slice(0, 9);
              this.DeactID = substringid;
            } else if (ResponseArray[1][0] == null) {
              this.DeactID = ResponseArray[0];
            }
            this.DeactBuilding = response.data.Values[0][1];
            this.DeactVersion = response.data.Values[0][2];
            this.DeactCurrentStatus = response.data.Values[0][3];
            this.DeactPosition = response.data.Values[0][5];
            this.DeactFeed = response.data.Values[0][6];
            this.DeactFloor = response.data.Values[0][7];

            this.responselist = response.data.Values;

            this.SearchTypeText = "Showing Device Search Results by Device ID";
            this.items = this.responseArray;
          });
        this.hideModal("DeactDevModal");
        this.DivID = "TerminateDevice";
      }
      if (Lookup === "TempDeactDevice") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/search";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "DeviceID",
          RequestVariable: this.SearchDeviceID.id,
          Company: this.Company,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            // this.buttonCooldown = false;
            let ResponseArray = response.data.Values;
            if (ResponseArray[1] != null) {
              let substringid = ResponseArray[0][0].slice(0, 9);
              this.DeactID = substringid;
            } else if (ResponseArray[1][0] == null) {
              this.DeactID = ResponseArray[0];
            }

            this.DeactBuilding = response.data.Values[0][1];
            this.DeactVersion = response.data.Values[0][2];
            this.DeactCurrentStatus = response.data.Values[0][3];
            this.DeactPosition = response.data.Values[0][5];
            this.DeactFeed = response.data.Values[0][6];
            this.DeactFloor = response.data.Values[0][7];

            this.responselist = response.data.Values;

            this.SearchTypeText = "Showing Device Search Results by Device ID";
            this.items = this.responseArray;
          });
        this.hideModal("TempDeactDevModal");
        this.DivID = "TempDeactivateDevice";
      }

      if (Lookup === "TempReactDevice") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/search";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "DeviceID",
          RequestVariable: this.SearchDeviceID.id,
          Company: this.Company,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            // this.buttonCooldown = false;
            let ResponseArray = response.data.Values;
            if (ResponseArray[1] != null) {
              let substringid = ResponseArray[0][0].slice(0, 9);
              this.DeactID = substringid;
            } else if (ResponseArray[1][0] == null) {
              this.DeactID = ResponseArray[0];
            }
            this.DeactBuilding = response.data.Values[0][1];
            this.DeactVersion = response.data.Values[0][2];
            this.DeactCurrentStatus = response.data.Values[0][3];
            this.DeactPosition = response.data.Values[0][5];
            this.DeactFeed = response.data.Values[0][6];
            this.DeactFloor = response.data.Values[0][7];

            this.responselist = response.data.Values;

            this.SearchTypeText = "Showing Device Search Results by Device ID";
            this.items = this.responseArray;
          });
        this.hideModal("TempActivateDevModal");
        this.DivID = "TempReactivateDevice";
      }

      if (Lookup === "DeactivatedDevice") {
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/search";
        let LookUpHeaders = this.$apikeyPost;
        this.LookUpRequest = {
          RequestType: "DeviceID",
          RequestVariable: this.SearchDeviceID.id,
          Company: this.Company,
        };
        axios
          .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
          .then((response) => {
            // this.buttonCooldown = false;
            let ResponseArray = response.data.Values;
            if (ResponseArray[1] != null) {
              let substringid = ResponseArray[0][0].slice(0, 9);
              this.DeactID = substringid;
            } else if (ResponseArray[1][0] == null) {
              this.DeactID = ResponseArray[0];
            }
            this.DeactBuilding = response.data.Values[0][1];
            this.DeactVersion = response.data.Values[0][2];
            this.DeactCurrentStatus = response.data.Values[0][3];
            this.DeactPosition = response.data.Values[0][5];
            this.DeactFeed = response.data.Values[0][6];
            this.DeactFloor = response.data.Values[0][7];

            this.responselist = response.data.Values;

            this.SearchTypeText = "Showing Device Search Results by Device ID";
            this.items = this.responseArray;
          });
        this.hideModal("DeactivateDeviceModal");
        this.DivID = "DeactivateDevice";
      }
      if (Lookup === "editSubgroup") {
        let LookUpUrlDevice =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/lookup";
        let LookUpHeadersDevice = this.$apikeyPost;
        let LookUpRequestDevice = {
          RequestType: "LocationSubgroup",
          Location: this.subGroupLocationToSearch.text,
        };
        axios
          .post(LookUpUrlDevice, LookUpRequestDevice, LookUpHeadersDevice)
          .then((response) => {
            // this.buttonCooldown = false;
            this.subgroupListArray = [];
            this.subgroupList = response.data.Values;
            for (let i = 0; i < this.subgroupList.length; i++) {
              this.subgroupListArray.push({ Name: this.subgroupList[i][0] });
            }
            this.hideModal("SubgroupEditModal");
            this.showModal("SubgroupSelectModal");
          });
      }
      if (Lookup === "selectSubgroup") {
        this.hideModal("SubgroupSelectModal");
        this.DivID = "EditSubgroup";
      }
    },

    filterLocations: function() {
      if (this.location.length == 0) {
        this.filteredlocations = this.locations;
      }
      this.filteredlocations = this.locations.filter((location) => {
        return location
          .toString()
          .toLowerCase()
          .startsWith(this.location.toString().toLowerCase());
      });
    },

    RegionSearch: function() {
      this.RegionsList = [];
      this.RegionsArray = [];
      let LookUpUrlRegion =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/lookup";
      let LookUpHeadersRegion = this.$apikeyPost;
      let LookUpRequestRegion = {
        RequestType: "RegionByCountry",
        CountryID: this.locCountry.id,
      };
      axios
        .post(LookUpUrlRegion, LookUpRequestRegion, LookUpHeadersRegion)
        .then((response) => {
          response;
          this.RegionsList = response.data.Values;
          for (let i = 0; i < this.RegionsList.length; i++) {
            var QuoteStr4 = this.RegionsList[i][0];
            this.RegionsArray.push({
              id: QuoteStr4,
              Region: this.RegionsList[i][1],
            });
          }
        });
    },
  },


  watch: {
    location() {
      this.filterLocations();
    },
    locCountry() {
      this.RegionSearch();
    },
    // buttonCooldown() {
      // this.btnCooldown();
    // },
  },
};
</script>

<style scoped>
input[type="text"],
input[type="date"],
select {
  width: 100%;

  padding: 5px 5px 5px 5px;

  border: solid 1px rgba(200, 200, 200, 0.5);

  background-color: rgb(245, 245, 245);
}
.form-control {
  width: 100%;
  border: solid 1px rgba(200, 200, 200, 0.5);
  border-radius: 25px;
  background-color: rgb(245, 245, 245);
  font-size: 0.9rem;
}

.container-fluid {
  border-style: none;
}

.card-body {
  border-style: none;
}

.collapse.show {
  border-style: none;
}

.container {
  border-style: none;
}

.row {
  border-style: none;
}
li {
  width: 100%;
}
input {
  margin-bottom: 8px;
}

input[type="number" i] {
  width: 30%;
}

.Auto {
  border: none;
  padding: none;
  margin: none;
}
.AutoDrop {
  width: 130%;
  text-align: left;
  float: right;
}

.locationAutoFill {
  border: none;
  padding: none;
  margin: none;
}

.locationAutoFillSpan {
  border: none;
  width: 50%;
  margin-left: 29%;
}

.locationAutoFillSpan li {
  background-color: whitesmoke;
}

.HandwashLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

.LocationHandwashAutoFillSpan {
  border: none;
  padding-left: 30%;
}

.LocationHandwashAutoFillSpan ul {
  width: 35%;
}

#AGPortalUser {
  margin-left: 10px;
}

.AutoDropDown {
  border: none;
  margin: none;
  padding: none;
}

.EditLocationAutoFillSpan {
  border: none;
}
.EditLocationAutoFillSpan ul {
  border: none;
  margin-left: 1%;
}

.EditLocationAutoFillSpan li {
  background: white;
}

.EditLocationDropdown {
  border: none;
  padding: none;
  margin: none;
}

#StaffRoleHide {
  border: none;
}
#LocationHide {
  border: none;
}

#DropdownAGRFIDRole {
  margin-left: 6px;
}

.lightText {
  text-align: center;
}

.LocationUnitAutoFillSpan {
  border: none;
}
.LocationUnitAutoFillSpan ul {
  border: none;
  margin-left: 10%;
}

.LocationUnitAutoFillSpan li {
  background: white;
}
.LocationDropdown {
  border: none;
}

#SubmitButtons {
  border: none;
  text-align: center;
}
.EditLocationDropdown input {
  margin-left: -5px;
}

#CenterButtons {
  text-align: center;
  border: none;
  padding: none;
  margin: none;
}

.tablinksActive {
  width: 25%;
}
.tablinks {
  border-right: 0.5px solid rgb(220, 220, 220);
  border-left: 0.5px solid rgb(220, 220, 220);
  width: 25%;
}

div.tab,
div.tabBottom {
  padding: 0;
}

.tablinksClientAdminActive {
  width: 50%;
  background: rgb(201, 201, 201);
}
.tablinksClientAdmin {
  width: 50%;
  border-color: rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  box-shadow: 0 0 40px 40px rgb(230, 230, 230) inset, 0 0 0 0 rgb(230, 230, 230);
}
.tablinksClientAdmin:hover {
  box-shadow: 100px 100px 100px 100px rgb(201, 201, 201) inset,
    0 0 0 0 rgb(201, 201, 201);
}

div.tabcontent {
  padding: 0;
}

.tablinksDeviceAdminActive {
  width: 25%;
  background: rgb(201, 201, 201);
}

.tablinksDeviceAdmin {
  width: 25%;
  border-color: rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  font-size: 13px;
  box-shadow: 0 0 40px 40px rgb(230, 230, 230) inset, 0 0 0 0 rgb(230, 230, 230);
}
.tablinksDeviceAdmin:hover {
  box-shadow: 100px 100px 100px 100px rgb(201, 201, 201) inset,
    0 0 0 0 rgb(201, 201, 201);
}
/* New Tabs -------------------------------------- New Tabs */

.reportTabLeft,
.reportTab {
  font-size: 14px;
  width: 25%;
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
}

.reportTabRight {
  border-top: solid 1px rgb(200, 200, 200);
  border-left: solid 0.5px rgb(200, 200, 200);
  border-right: solid 0.5px rgb(200, 200, 200);
  font-size: 14px;
  width: 25%;
}

.reportTabActiveLeft,
.reportTabActiveRight {
  font-size: 14px;
  width: 25%;
}

.reportTabActive {
  width: 25%;
  font-size: 14px;
}

.reportTabActiveLeft:hover,
.reportTabActiveRight:hover,
.reportTabActive:hover {
  background-color: var(--TabActiveHoverColor);
}

.reportTabLeft:hover,
.reportTabRight:hover,
.reportTab:hover {
  background-color: var(--TabHoverColor);
}
.AdminButton:hover {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.AdminButton {
  border-style: solid;
  border-color: white;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 10px;
  background-color: black;
}
.tablinksLocationAdminActive {
  width: 33.3%;
  background: rgb(201, 201, 201);
}

.tablinksLocationAdmin {
  width: 33.3%;
  border-color: rgb(0, 0, 0);
  color: rgb(0, 0, 0);
  font-size: 13px;
  box-shadow: 0 0 40px 40px rgb(230, 230, 230) inset, 0 0 0 0 rgb(230, 230, 230);
}
.tablinksLocationAdmin:hover {
  box-shadow: 100px 100px 100px 100px rgb(201, 201, 201) inset,
    0 0 0 0 rgb(201, 201, 201);
}
.Modal {
  background-color: var(--BackgroundModalColour);
  border-radius: 15px;
  border: solid 1px rgb(0, 204, 255);
}

.scrollList {
  max-height: 100px;
  overflow: scroll;
  overflow-x: hidden;
}

.textArea {
  min-height: 80px;
  overflow: scroll;
  overflow-x: hidden;
}
.bv-no-focus-ring {
  text-align: left;
}
</style>
